// extracted by mini-css-extract-plugin
export const newsCard = "R_b6";
export const newsImage = "R_b7";
export const newsBody = "R_b8";
export const title = "R_x";
export const statusRoot = "R_5";
export const promoteTxt = "R_b9";
export const createdTxt = "R_3";
export const space = "R_bh";